/* External dependencies */
import * as XLSX from 'xlsx';

/* Local dependencies */
import { SourceArray } from '../goods-specifications/createConsigneeGoodsSpecifications/redux/types';

interface ExcelBuffer {
  buffer: ArrayBuffer;
  linesCount: number;
}

export async function convertArrayToExcelBuffer(
  arr: SourceArray,
): Promise<ExcelBuffer> {
  const sheet = XLSX.utils.json_to_sheet(arr);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, sheet);

  const excelBuffer = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });

  return {
    buffer: excelBuffer,
    linesCount: arr.length || 0,
  };
}
